<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.97073 12.0909C8.11488 12.0901 8.25298 12.0328 8.35546 11.9314C8.45795 11.83 8.51667 11.6926 8.51906 11.5484V2.94174L8.48156 1.74341L9.13739 2.43091L10.4674 3.81841C10.5152 3.87147 10.5735 3.91398 10.6387 3.94325C10.7038 3.97252 10.7743 3.9879 10.8457 3.98841C11.1291 3.98841 11.3507 3.78008 11.3507 3.49674C11.3505 3.42767 11.3358 3.35942 11.3075 3.2964C11.2792 3.23338 11.238 3.177 11.1866 3.13091L8.36823 0.388411C8.22906 0.249245 8.10989 0.205078 7.97073 0.205078C7.82573 0.205078 7.70573 0.249245 7.56739 0.388411L4.74156 3.13091C4.64156 3.23841 4.57739 3.35174 4.57739 3.49674C4.57739 3.78008 4.79239 3.98841 5.08239 3.98841C5.21489 3.98841 5.36573 3.93174 5.46656 3.81841L6.79156 2.43091L7.45906 1.74341L7.41656 2.94174V11.5484C7.41656 11.8451 7.66906 12.0901 7.97156 12.0901L7.97073 12.0909Z"
      fill="#007AFF"
    />
    <path
      d="M12.6433 18.3955C14.2766 18.3955 15.0958 17.5696 15.0958 15.9621V7.72047C15.0958 6.11214 14.2758 5.29297 12.6433 5.29297H10.3416V6.40964H12.6174C13.4816 6.40964 13.9799 6.8763 13.9799 7.77714V15.9046C13.9799 16.8063 13.4816 17.273 12.6174 17.273H3.31159C2.42825 17.273 1.94908 16.8063 1.94908 15.9046V7.77714C1.94908 6.87547 2.42825 6.4088 3.31159 6.4088H5.59409V5.29297H3.28575C1.65909 5.29297 0.833252 6.1063 0.833252 7.72047V15.9621C0.833252 17.5755 1.65909 18.3955 3.28575 18.3955H12.6433Z"
      fill="#007AFF"
    />
  </svg>
</template>
